import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["setCodesSubmitted", "setCode"]

  resetSetCodes() {
    if (this.hasSetCodesSubmittedTarget) {
      this.setCodesSubmittedTarget.disabled = true
    }

    this.setCodeTargets.forEach((input) => {
      input.disabled = true
    })
  }
}
